import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], term: any): any {
    if(!term){
      console.log(1)
      return items;
    }
    let a = items.filter(item => {
      return term.indexOf(item.brand_id) !== -1
      // item.brand_id.indexOf(term) !== -1
    });
    console.log(a,term)
    return a;
 }

}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/pipes/filter.pipe.ts